import React, {useEffect, useState} from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';
import {User} from "firebase";
import isNil from "lodash/isNil";
import './Inbox.css';

import firebase from "../firebase";

const db = firebase.firestore();

export interface Props {
  user: User;
};

interface MessageThread {
  id: string;
  data: firebase.firestore.DocumentData;
}

const Inbox = ({user} : Props) => {
  const [threads, setThreads] = useState<MessageThread[]>([]);
  const [selectedThreadIdx, ] = useState<number>(0);
  const [currentMessage, setCurrentMessage] = useState<string>("");

  useEffect(() => {
    if (!isNil(user)) {
      const threadsQuery = db.collection("threads").where('uids', 'array-contains', user.uid);

      threadsQuery.onSnapshot(querySnapshot => {
        setThreads(querySnapshot.docs.map(doc => {return {id: doc.id, data: doc.data()}}));
      });

      return () => threadsQuery.onSnapshot(() => {})();
    }
  }, [user]);

  let selectedThread = threads.length > selectedThreadIdx ? threads[selectedThreadIdx] : null;

  return (
    <div className="inbox main">
      <div className="inbox-sidebar">
        <div className="inbox-sidebar-header">
          <div className="inbox-sidebar-label">Messaging</div>

        </div>
        <div className="inbox-thread-list">
          {
            threads.map((thread, idx) => {
              return <div key={idx} className="inbox-thread">
                {thread.data.uids.filter((uid: string) => uid !== user.uid).join(", ")}
              </div>
            })
          }
        </div>
      </div>
      <div className="inbox-main">
        <div className="inbox-thread-name">
          {
            selectedThread && selectedThread.data.uids.filter((uid: string) => uid !== user.uid).join(", ")
          }
        </div>
        <ScrollToBottom className="message-list">
          {
            selectedThread && selectedThread.data.messages.map((message: any) =>
              <div className="message">{message.from_name}: {message.content}</div>)
          }
        </ScrollToBottom>
        <input className="message-input"
               value={currentMessage}
               onChange={event => setCurrentMessage(event.target.value)}
               onKeyDown={e => {
                 if (e.key === 'Enter' && selectedThread) {
                   selectedThread.data.messages.push({
                     from: user.uid,
                     from_name: user.displayName,
                     content: currentMessage
                   });
                   setCurrentMessage("");
                   db.collection('threads').doc(selectedThread.id).set(selectedThread.data);
                 }
               }}
        />
      </div>
    </div>);
};

export default Inbox;